import { render, staticRenderFns } from "./PromoterDashboard.vue?vue&type=template&id=423d501a&scoped=true&"
import script from "./PromoterDashboard.vue?vue&type=script&lang=js&"
export * from "./PromoterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PromoterDashboard.vue?vue&type=style&index=0&id=423d501a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d501a",
  null
  
)

export default component.exports